import { render, staticRenderFns } from "./TabOVRepuestos.vue?vue&type=template&id=a8200f3c&scoped=true&lang=pug"
import script from "./TabOVRepuestos.vue?vue&type=script&lang=js"
export * from "./TabOVRepuestos.vue?vue&type=script&lang=js"
import style0 from "./TabOVRepuestos.vue?vue&type=style&index=0&id=a8200f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8200f3c",
  null
  
)

export default component.exports